import React from "react";

/**
 * Accepts an `input` which the output is set to only after the `input` has not changed for `delay` milliseconds.
 */
export function useDebounce<T>(input: T, delay: number): T {
  const [output, setOutput] = React.useState(input);

  const isMountedRef = React.useRef(true);
  React.useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    []
  );

  React.useEffect(() => {
    if (delay === 0) {
      setOutput(input);
      return;
    }

    const timeoutId = setTimeout(() => {
      if (isMountedRef.current) {
        setOutput(input);
      }
    }, delay);
    return () => clearTimeout(timeoutId);
  }, [input, delay]);

  return output;
}
